import { render, staticRenderFns } from "./GraficaVolumenesGsv.vue?vue&type=template&id=192eb7b9"
import script from "./GraficaVolumenesGsv.vue?vue&type=script&lang=js"
export * from "./GraficaVolumenesGsv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports